import { PageTitleConstants } from "./PageTitleConstants";

export const QuestionTypeEnum = {
  Text: {
    value: 1,
    description: "Tekstowy",
  },

  Date: {
    value: 2,
    description: "Data",
  },

  Number: {
    value: 3,
    description: "Liczbowy",
  },

  YesNoSelect: {
    value: 4,
    description: "Pole wyboru Tak/Nie",
  },

  OptionList: {
    value: 5,
    description: "Lista opcji + wielokrotny wybór",
  },

  Mixed: {
    value: 6,
    description: "Mieszane",
  },

  Other: {
    value: 7,
    description: "Inne",
  },

  Content: {
    value: 8,
    description: "Sama treść",
  },
};

export const DisplayTypeEnum = {
  List_Radio: {
    value: 1,
    description: "Radiobuttony",
  },
  List_Dropdown: {
    value: 2,
    description: "Lista rozwijalna (dropdown)",
  },
  Text_SingleLine: {
    value: 3,
    description: "Pojedyncza linia",
  },
  Text_MultipleLines: {
    value: 4,
    description: "Wiele linii",
  },
};

export const QuestionnairesEnum = {
  First: {
    value: 1,
  },
  Module1: {
    value: 2,
  },
  Module2: {
    value: 3,
  },
  Module2v2: {
    value: 4,
  },
};

export const ProcessStatusEnum = {
  ApplicationForm: {
    value: 0,
    description: PageTitleConstants.ApplicationForm,
  },
  Survey: {
    value: 1,
    description: PageTitleConstants.Survey,
  },
  ContractForm: {
    value: 10,
    description: PageTitleConstants.ContractForm,
  },
  CompletingBalanceSheetOfModuleFirst: {
    value: 4,
    description: PageTitleConstants.CompletingBalanceSheetOfModuleFirst,
  },
  CompletingBalanceSheetOfModuleFirstByAdvisor: {
    value: 5,
    description:
      PageTitleConstants.CompletingBalanceSheetOfModuleFirstByAdvisor,
  },
  Store: {
    value: 6,
    description: PageTitleConstants.Store,
  },
  StoreSummary: {
    value: 7,
    description: PageTitleConstants.StoreSummary,
  },
  StoreEdit: {
    value: 8,
    description: PageTitleConstants.StoreEdit,
  },
  CompletingBalanceSheetOfModuleSecond: {
    value: 9,
    description: PageTitleConstants.CompletingBalanceSheetOfModuleSecond,
  },
  CompletingBalanceSheetOfModuleSecondv2: {
    value: 11,
    description: PageTitleConstants.CompletingBalanceSheetOfModuleSecondv2,
  },
  OrderingVouchers: {
    value: 10,
    description: PageTitleConstants.OrderingVouchers,
  },
  EndWithOrder: {
    value: 11,
    description: PageTitleConstants.EndWithOrder,
  },
  EndWithoutOrder: {
    value: 12,
    description: PageTitleConstants.EndWithoutOrder,
  },
  StoreExclusive: {
    value: 9,
    description: PageTitleConstants.StoreExclusive,
  },
  StoreExclusiveSummary: {
    value: 9,
    description: PageTitleConstants.StoreExclusiveSummary,
  },
  ContractFormv2: {
    value: 15,
    description: PageTitleConstants.ContractFormv2,
  },
};

export const M1_QuestionTypeEnum = {
  Text: {
    value: 1,
    description: "Tekstowy",
  },

  Date: {
    value: 2,
    description: "Data",
  },

  Number: {
    value: 3,
    description: "Liczbowy",
  },

  YesNoSelect: {
    value: 4,
    description: "Pole wyboru Tak/Nie",
  },

  OptionList: {
    value: 5,
    description: "Lista opcji + wielokrotny wybór",
  },

  Mixed: {
    value: 6,
    description: "Mieszane",
  },

  Table: {
    value: 7,
    description: "Tabela",
  },

  Content: {
    value: 8,
    description: "Sama treść",
  },

  Scale: {
    value: 9,
    description: "Skala",
  },

  Chart: {
    value: 10,
    description: "Wykres",
  },

  Statistic: {
    value: 11,
    description: "Statystyka",
  },

  Area: {
    value: 12,
    description: "Obszar rozwoju",
  },

  Feedback: {
    value: 13,
    description: "Informacja zwrotna",
  },
};

export const M1_AnswersTypeEnum = {
  Text: {
    value: 1,
    description: "Tekst",
  },

  Textarea: {
    value: 2,
    description: "Textarea",
  },

  Date: {
    value: 3,
    description: "Data",
  },

  Number: {
    value: 4,
    description: "Numer",
  },

  OptionList: {
    value: 5,
    description: "Lista Opcji",
  },

  MultipleColumn: {
    value: 6,
    description: "Powielana kolumna",
  },
};

export const M1_QuestionConditions = {
  Bigger: {
    value: "1",
    description: "Większe",
  },

  Smaller: {
    value: "2",
    description: "Mniejsze",
  },

  Different: {
    value: "3",
    description: "Różne",
  },

  Equal: {
    value: "4",
    description: "Równe",
  },

  Containing: {
    value: "5",
    description: "Zawierajace",
  },

  Not_containing: {
    value: "6",
    description: "Nie zawierające",
  },
};

export const M1_ContentVideoStatuses = {
  NoValid: {
    value: 1,
    description: "Nie potrzebujace walidacji",
  },

  UnValid: {
    value: 2,
    description: "Nie przechodzace walidacji",
  },

  Valid: {
    value: 3,
    description: "Zwalidowane",
  },
};

export const M1_FormApplicationStatuses = {
  Registered: {
    value: "registered",
    description: "Zarejestrowany",
  },
  ReadyToVerify: {
    value: "ready_to_verify",
    description: "Do weryfikacji",
  },
  VerificationOngoing: {
    value: "ongoing_verification",
    description: "Weryfikacja w toku",
  },
  ToCorrect: {
    value: "to_correct",
    description: "W poprawie",
  },
  Verified: {
    value: "verified",
    description: "Zweryfikowany poprawnie",
  },
  ResendAnnouncement: {
    value: "resend_announcement",
    description: "Odesłał oświadczenie",
  },
  ProjectMember: {
    value: "project_member",
    description: "Uczestnik projektu",
  },
};

export const M1_ContractStatuses = {
  ContactInPreparation: {
    value: 1,
    description: "Umowa w przygotowaniu",
    range: [1, 2],
  },

  ContractToSign: {
    value: 2,
    description: "Umowa do podpisu",
    range: [3],
  },

  ContractInProgress: {
    value: 3,
    description: "Umowa w obiegu",
    range: [7, 10, 6, 11, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
  },

  ContractAgreement: {
    value: 4,
    description: "Umowa zawarta",
    range: [4, 13],
  },

  ContractExpires: {
    value: 5,
    description: "Umowa wygaszona",
    range: [5],
  },

  ContractDisAgreement: {
    value: 6,
    description: "Umowa niepodpisana",
    range: [12],
  },

  ContractEnd: {
    value: 7,
    description: "Umowa zakończona",
    range: [8, 9],
  },
};

export const M1_StageStatuses = {
  ClientPanel: {
    value: 1,
    description: "Panel klienta",
    range: [],
  },

  ContractForm: {
    value: 2,
    description: "Formularz zgłoszeniowy",
    range: [0, 1],
  },

  Autoanalyse: {
    value: 3,
    description: "Autoanaliza",
    range: [2, 3],
  },

  SelfRate: {
    value: 4,
    description: "Samoocena",
    range: [4, 5, 6, 7, 8],
  },

  AddOffer: {
    value: 5,
    description: "Oferta dodatkowa",
    range: [],
  },

  DevelopmentGoal: {
    value: 6,
    description: "Twój cel rozwojowy",
    range: [9, 10],
  },

  Contract: {
    value: 7,
    description: "Umowa o dofinansowanie",
    range: [11],
  },

  DevelopmentGoalv2: {
    value: 8,
    description: "Twój cel rozwojowy - drugie zamówienie",
    range: [12],
  },

  Contractv2: {
    value: 9,
    description: "Druga umowa o dofinansowanie",
    range: [15],
  },
};

export const TYPE_OF_SERVICE = {
  EXCLUSIVE: {
    id: 2,
  },
};

export const Services_Types_Enum = {
  Consultation: {
    id: 1,
    name: 'Konsultacje'
  },
  Exclusive: {
    id: 2,
    name: 'Oferta dodatkowa'
  },
  Meeting: {
    id: 3,
    name: 'Spotkanie z klientem'
  },
}

export const Meeting_Types_Enum = {
  Online: {
    id: 1,
    name: 'Przez internet'
  },
  OnSite: {
    id: 2,
    name: 'Stacjonarne'
  },
}

export const ClientSteps = {
  AutoAnalysisNotStarted: {
    value: "auto_analysis_not_started",
    description: "Nie rozpoczęto autoanalizy",
  },
  AutoAnalysisInProgress: {
    value: "auto_analysis_in_progress",
    description: "W trakcie autoanalizy",
  },
  AutoAnalysisCompleted: {
    value: "auto_analysis_completed",
    description: "Zakończono autoanalize",
  },
  SelfEsteemNotStarted: {
    value: "self_esteem_not_started",
    description: "Nie rozpoczęto samooceny",
  },
  SelfEsteemInProgress: {
    value: "self_esteem_in_progress",
    description: "W trakcie samooceny",
  },
  SelfEsteemCompleted: {
    value: "self_esteem_completed",
    description: "Zakończono samoocenę",
  },
  OrderNotStarted: {
    value: "order_not_started",
    description: "Przed złożeniem zamówienia",
  },
  OrderCompleted: {
    value: "order_completed",
    description: "Złożono zamówienie",
  },
  ContractNotSigned: {
    value: "contract_not_signed",
    description: "Przed podpisaniem umowy",
  },
  ContractSigned: {
    value: "contract_signed",
    description: "Podpisano umowę",
  },
  OrderSecondNotStarted: {
    value: "order_second_not_started",
    description: "Przed złożeniem drugiego zamówienia",
  },
  OrderSecondCompleted: {
    value: "order_second_completed",
    description: "Złożono drugie zamówienie",
  },
  ContractSecondNotSigned: {
    value: "contract_second_not_signed",
    description: "Przed podpisaniem drugiej umowy",
  },
  ContractSecondSigned: {
    value: "contract_second_signed",
    description: "Podpisano drugą umowę",
  },
  DoesNotParticipate: {
    value: "does_not_participate",
    description: "Nie uczestniczy",
  }
};

export const RecruitmentTypes = {
  Standard: {
    value: "standard",
    description: "Rekrutacja standardowa",
  },
  Special: {
    value: "special",
    description: "Rekrutacja specjalna",
  },
  New: {
    value: "new",
    description: "Rekrutacja nowa",
  },
};

export const ProgressEnum = {
  NotStarted: {
    value: "not-started",
    description: "Nie rozpoczęto",
  },
  InProgress: {
    value: "in-progress",
    description: "W trakcie",
  },
  Completed: {
    value: "completed",
    description: "Zakończono",
  },
};